import WebApp from '@twa-dev/sdk';

export interface Book {
  id: number;
  title: string;
  description: string;
  available: boolean;
  reserverId?: number;  // ID пользователя, который забронировал книгу
}

export interface Shelf {
  id: number;
  name: string;
  books: Book[];
}

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Общие функции для работы с API
const handleResponse = async (response: Response) => {
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Ошибка при запросе к API');
  }
  return response.json();
};

const api = {
  // Книги
  books: {
    getAll: async (): Promise<Book[]> => {
      const response = await fetch(`${API_BASE_URL}/books`);
      return handleResponse(response);
    },

    getReservedByUser: async (userId: number): Promise<Book[]> => {
      const response = await fetch(`${API_BASE_URL}/books/reserved/${userId}`);
      return handleResponse(response);
    },

    getById: async (id: string): Promise<Book> => {
      const response = await fetch(`${API_BASE_URL}/books/${id}`);
      return handleResponse(response);
    },

    reserve: async (bookId: number, userId: number): Promise<void> => {
      const response = await fetch(`${API_BASE_URL}/books/reserve`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ bookId, userId }),
      });
      return handleResponse(response);
    },

    unreserve: async (bookId: number, userId: number): Promise<void> => {
      const response = await fetch(`${API_BASE_URL}/books/unreserve`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ bookId, userId }),
      });
      return handleResponse(response);
    },
  },

  // Полки
  shelves: {
    getAll: async (): Promise<Shelf[]> => {
      const response = await fetch(`${API_BASE_URL}/shelves`);
      return handleResponse(response);
    },

    getById: async (id: string): Promise<Shelf> => {
      const response = await fetch(`${API_BASE_URL}/shelves/${id}`);
      return handleResponse(response);
    },
  },

  // Telegram WebApp
  telegram: {
    isInitialized: () => WebApp.isExpanded,
    getUser: () => WebApp.initDataUnsafe.user,
    showAlert: (message: string) => WebApp.showAlert(message),
    ready: () => WebApp.ready(),
    expand: () => WebApp.expand(),
  },
};

export default api; 